(function (app, ng) {
    app.controller("addSaleController", addSaleController);

    addSaleController.$inject = ["$mdDialog", "figToaster", "marketingTrackerSalesTrackerInputApi", "marketingTrackerSalesTrackerSettingsApi", "_"];
    function addSaleController($mdDialog, figToaster, marketingTrackerSalesTrackerInputApi, marketingTrackerSalesTrackerSettingsApi, _) {
        var $ctrl = this;
        ng.extend($ctrl, {
            sale: {
                LinesOfBusinessAmounts: [],
                ClientName: '',
                Source: {},
                Advisors: [],
                Date: '',
                OpportunityId: '',
            },
            isLoading: true,
            saleCreationSuccess: false,
            saleCreationFailure: false,
            menu: 'addSaleForm',
        });

        $ctrl.getTotalSoldAmount = function () {
            if ($ctrl.sale.LinesOfBusinessAmounts.length <= 0) return 0;
            return $ctrl.sale.LinesOfBusinessAmounts.map(function (lob) { return parseFloat(lob.Amount) }).reduce(function (accumulator, current) { return accumulator + current; }, 0);
        }

        function preFillSaleFromOpportunity() {
            $ctrl.sale.LinesOfBusinessAmounts = $ctrl.lobs.map(function (lob) { return { LineOfBusinessId: lob.Id, Amount: 0, LineOfBusinessName: lob.LineOfBusinessName } });
            $ctrl.sale.Source = $ctrl.opportunity.Source;
            $ctrl.sale.ClientName = $ctrl.opportunity.ClientName;
            $ctrl.sale.Advisors = $ctrl.opportunity.Advisors;
            $ctrl.sale.Date = new Date().toLocaleDateString();
            $ctrl.sale.OpportunityId = $ctrl.opportunity.Id;
            $ctrl.isLoading = false;
        }

        $ctrl.createSale = function () {
            $ctrl.isLoading = true;
            return marketingTrackerSalesTrackerInputApi.createSale($ctrl.sale)
                .then(function (response) {
                    $ctrl.isLoading = false;
                    $ctrl.saleCreationSuccess = true;
                    $ctrl.history.SaleModels.push(response);
                    $ctrl.getEachSaleHistorySoldAmount();
                })
                .catch(function () {
                    $ctrl.isLoading = false;
                    $ctrl.saleCreationFailure = true;
                })
        }

        $ctrl.close = function () {
            if ($ctrl.saleCreationSuccess) {
                var totalSold = $ctrl.getTotalSoldAmount();
                $mdDialog.hide(totalSold);
            }
            else {
                $mdDialog.cancel();
            }
        }

        $ctrl.removeSoldAmount = function ($event) {
            var alert = $mdDialog.confirm({
                clickOutsideToClose: true,
                //title: 'This is an alert title',
                textContent: 'Are you sure you to remove this amount?',
                ariaLabel: 'Alert Dialog',
                ok: 'Yes',
                cancel: 'Cancel',
                targetEvent: $event,
                multiple: true
            });

            $mdDialog.show(alert).then(function (response) {
                $ctrl.opportunity.SoldAmount = 0;
                return marketingTrackerSalesTrackerInputApi.updateOpportunity($ctrl.opportunity);
            }).catch(function () {
            });


        }

        $ctrl.$onInit = function () {
            marketingTrackerSalesTrackerSettingsApi.getLinesOfBusiness().then(function (response) {
                $ctrl.lobs = response;
                preFillSaleFromOpportunity();
            })

            $ctrl.getEachSaleHistorySoldAmount();
        };

        $ctrl.getEachSaleHistorySoldAmount = function () {
            $ctrl.history.SaleModels.map(function (sm) {
                sm.TotalAmount = sm.LinesOfBusinessAmounts.map(function (lobAm) {
                    return lobAm.Amount;
                }).reduce(function (total, num) {
                    return total + num;
                })
            });
        };

        $ctrl.getTotalHistorySoldAmount = function () {
            var amount = $ctrl.opportunity.SoldAmount;
            if ($ctrl.history.SaleModels.length > 0) {
                amount += $ctrl.history.SaleModels.map(function (sm) {
                    return sm.LinesOfBusinessAmounts.map(function (lobAm) { return lobAm.Amount; })
                .reduce(function (total, num) {return total + num;});
                })
                .reduce(function (total, num) { return total + num;});
            }
            
            return amount;
        }

        $ctrl.getRemainingOpportunity = function () {
            var totalSold = $ctrl.getTotalHistorySoldAmount();
            var opportunityAmount = $ctrl.opportunity.OpportunityAmount;
            if (opportunityAmount - totalSold < 0) return 0;
            else return opportunityAmount - totalSold;
        }

        $ctrl.chekForNullAmount = function (lob) {
            if (!lob.Amount) {
                lob.Amount = 0;
            }
        }
    }

})(window.app, window.angular);